import { RefObject, useEffect } from 'react'

interface UsePointerDownOutsideProps {
  enabled: boolean
  containerRef: RefObject<HTMLElement | null>
  ignoredSelectors?: string[]
  onOutsidePointerDown: () => void
}

export const usePointerDownOutside = ({
  enabled,
  containerRef,
  ignoredSelectors = [],
  onOutsidePointerDown,
}: UsePointerDownOutsideProps) => {
  useEffect(() => {
    if (!enabled) {
      return
    }

    const handlePointerDown = (event: PointerEvent) => {
      const target = event.target

      if (!(target instanceof Node)) {
        return
      }

      if (containerRef.current?.contains(target)) {
        return
      }

      if (
        target instanceof Element &&
        ignoredSelectors.some((selector) => target.closest(selector))
      ) {
        return
      }

      onOutsidePointerDown()
    }

    document.addEventListener('pointerdown', handlePointerDown, true)

    return () => {
      document.removeEventListener('pointerdown', handlePointerDown, true)
    }
  }, [containerRef, enabled, ignoredSelectors, onOutsidePointerDown])
}
